
  

import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
   apiKey: "AIzaSyBfUWTDkWzYmraJH0o6kBU-22mX0NV802E",
  authDomain: "karimpur-netzone.firebaseapp.com",
  projectId: "karimpur-netzone",
  storageBucket: "karimpur-netzone.firebasestorage.app",
  messagingSenderId: "238911936931",
  appId: "1:238911936931:web:256ea9c81f45430f3da216",
  measurementId: "G-JTYLBVG92W"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;